import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { Offer } from '@wwt/entities/search-response'

import { ALLOW_SHOW_RESERVATION_TAB } from '@/features/ReservationTab/config/allowShowReservationTab'

export const useDefaultTabName = (offer: Offer) => {
	const { t } = useTranslation('room-page')

	return useMemo(() => {
		const status = offer.IDs.status
		const isReservationTabAllowed = ALLOW_SHOW_RESERVATION_TAB.includes(status)
		const tabName = isReservationTabAllowed
			? t('reservationVoucherTab')
			: t('room')

		return tabName
	}, [offer.IDs.status, t])
}
